module.exports = __webpack_public_path__ + "svgs/checkup-empty.f50b40a7.svg";